//#region src/redux/notification/thunk-types.ts
var thunkTypes = {
	SHOW_NOTIFICATION: "notification/showNotification",
	CLEAR_NOTIFICATION: "notification/clearNotification"
};
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map